<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='数据统计到昨日数据，数据每天00：00自动更新' :padding='true'></SmallSquare>
    <a-card :bordered="false" >
      <a-form :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline' class="m-b-20">
        <a-form-item label="" name='keyword' style="width:330px">
          <a-input-group compact>
            <a-select v-model:value="search.key_type">
              <a-select-option value="store_clerk__name">导购名称</a-select-option>
              <a-select-option value="store_name">所属门店</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="请选择">
          <a-select v-model:value="search.search_date_type" style="width: 120px" ref="select" @change="handleChange">
            <a-select-option :value="1">日</a-select-option>
            <a-select-option :value="2">自然周</a-select-option>
            <a-select-option :value="3">自然月</a-select-option>
            <a-select-option :value="4">近7天</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="">
          <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
          <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" @change="changeWeek" v-model:value="weekTime" />
          <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onSearch">搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' bordered :columns='columns1' :data-source='list'>
        <!-- <template v-slot:action="{ record }">
        <a href="javascript:;" @click="$router.push({path:'/antiFleeingGoods/statistics/dealerAnalyze',query:{'dealer_sn':record.dealer_sn,'dealer_name':record.dealer_name,'search_time':search.search_time,'search_date_type':search.search_date_type}})">查看分析</a>
      </template> -->
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { inject, onMounted } from "@vue/runtime-core";
import { activity_store_code , activity_store_statisticals } from "@/api/guide";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import {} from "@ant-design/icons-vue";
export default {
  components: {},
  setup() {
    const momentTime = inject("momentTime");

    const search = ref({
      page: 1,
      limit: 10,
      key_type: "store_clerk__name",
      keyword: "",
      start_time: "",
      end_time: "",
      search_date_type: 1,
    });
    const state = reactive({
      list: [],
      total: 0,
      line: [],
      detail: {},
      disabledDate: function (current) {
        return (
          current && current > momentTime().subtract(0, "days").endOf("day")
        );
      },
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      console.log(search.value.search_time);
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      initData();
    };
    // 切换时间
    const handleChange = (e) => {
      console.log(e);
      search.value.search_time = "";
      switch (e) {
        case 1:
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
        case 2:
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case 3:
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
        case 4:
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
      initData();
    };
    // 切换周
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    let columns1 = [
       {
        title: "导购员",
        dataIndex: "clerk__name",
        key: "clerk__name",
      },
      {
        title: "所属门店",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "中奖次数",
        dataIndex: "award_num",
        key: "award_num",
        width: 200,
      },
        {
        title: "红包金额",
        dataIndex: "money_num",
        key: "money_num",
        width: 200,
      },
        {
        title: "积分数量",
        dataIndex: "point_num",
        key: "point_num",
        width: 200,
      },
    ];

    var $moment = inject("momentTime");
    var $route = inject("$route");
    const form = ref({
      keyward: "",
      key_type: "store_name",
    });
    const getTable = async () => {
      switch (search.value.search_date_type) {
        case 1:
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case 2:
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case 3:
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      let result = await activity_store_code(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      state.list = result.data.data;
      state.total = result.data.total;
    };

    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    var initData = async () => {
      console.log(search.value);
      setTimeout(async () => {
        let result = await activity_store_code(search.value)
          .then((res) => res.data)
          .catch((error) => error);
        state.detail = result.data;
        getTable();
      }, 1);
    };
    onMounted(() => {
      initData(search.value);
      handleChange(1);
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      handleChange,
      onSearch,
      changeWeek,
      columns1,
      form,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;

    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
}
</style>